module.exports = __webpack_public_path__ + "img/NBL1South.a4096b7c.png";